import { render, staticRenderFns } from "./WashStatus.vue?vue&type=template&id=1b4f1ece&scoped=true"
import script from "./WashStatus.vue?vue&type=script&lang=js"
export * from "./WashStatus.vue?vue&type=script&lang=js"
import style0 from "./WashStatus.vue?vue&type=style&index=0&id=1b4f1ece&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f1ece",
  null
  
)

export default component.exports